import React, { Component, Fragment } from "react";
import { removeAllMarkers, trxNowAddMarkersToMap } from "./TrxNowMapFunctions";
import { devLog } from "utils/devLog";
import onResize from "simple-element-resize-detector";

// available map markers
import DestMapMarker from "../../../assets/ui-img/map-markers/markerServiceLocation.png";
import TowMapMarker from "../../../assets/ui-img/map-markers/markerTow.png";

/**
 * <TrxNowMap />
 * Props:
 * - width: string (%, px, etc)
 * - height: (see above)
 * - zoom: integer (defaults to 15)
 * - locationCoordsList: array of coordinates
 * - disablementCoords: {lat, lng} pair
 * - destinationCoords: {lat, lng} pair
 */
export default class TrxNowMap extends Component {
  mapRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      map: null,
      H: null,
      disablementCoords: props.disablementCoords,
      destinationCoords: props.destinationCoords,
      locationCoordsList: props.locationCoordsList,
      zoom: props.zoom || 10,
      mapWidth: props.width, // || "100%",
      mapHeight: props.height, // || "500px",
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.disablementCoords !== this.props.disablementCoords) {
      devLog("Coords are not the same");
      this.setState({ disablementCoords: this.props.disablementCoords }, () => {
        const coordsList = this.getAllCoords();

        //removeAllMarkers(this.state.map, this.state.H);
        trxNowAddMarkersToMap(this.state.map, this.state.H, coordsList);
      });
    }
  }

  componentDidMount() {
    const H = window.H;
    const platform = new H.service.Platform({
      //apikey: "IkIwLN86NvpYn3Bw9vYEDaGeddpA0vjiYhL1VBKX3j8"  // tkey
      apikey: "LJ1lYSRjmFn_a2rQKMRXjEolp-HHnrpru0AYUHuv4Oo", // pkey
    });

    const defaultLayers = platform.createDefaultLayers();

    const map = new H.Map(this.mapRef.current, defaultLayers.vector.normal.map, {
      center: {
        lat: this.state.disablementCoords?.lat || 0,
        lng: this.state.disablementCoords?.lng || 0,
      },
      zoom: this.state.zoom || 10,
      pixelRatio: window.devicePixelRatio || 1,
      padding: { top: 80, left: 50, bottom: 60, right: 50 },
    });

    // MapEvents enables the event system
    // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
    // This variable is unused and is present for explanatory purposes
    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));

    // Create the default UI components to allow the user to interact with them
    // This variable is unused
    const ui = H.ui.UI.createDefault(map, defaultLayers);

    this.setState({ map: map, H: H });

    const coordsList = this.getAllCoords();

    // add all the markers to the map
    trxNowAddMarkersToMap(map, H, coordsList);

    // handle resizing
    onResize(this.mapRef.current, () => {
      map.getViewPort().resize();
    });
  }

  componentWillUnmount() {
    this.state.map.dispose();
  }

  getAllCoords() {
    let coordsList = [];

    if (this.state.disablementCoords) {
      coordsList.push({ coords: this.state.disablementCoords, icon: null });
    }

    // if destination location is given we display it, plus give it the location
    if (this.state.destinationCoords) {
      coordsList.push({ coords: this.state.destinationCoords, icon: TowMapMarker });
    }

    // if locationCoords is provided, loop through the locations and display them
    if (this.state.locationCoordsList) {
      let locationObjectList = this.state.locationCoordsList.map((locCoords) => ({
        coords: locCoords,
        icon: DestMapMarker,
      }));

      coordsList = coordsList.concat(locationObjectList);
    }

    return coordsList;
  }

  render() {
    return <div ref={this.mapRef} style={{ width: this.state.mapWidth, height: this.state.mapHeight }} />;
  }
}
